import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "24x24/safari"
  }, React.createElement("path", {
    id: "dfdg",
    d: "M12.0057 23C18.0191 23 23 18.0191 23 11.9943C23 5.98092 18.0077 1 11.9943 1C5.98092 1 1 5.98092 1 11.9943C1 18.0191 5.99226 23 12.0057 23ZM12.0057 21.0371C6.99072 21.0371 2.97421 17.0206 2.97421 11.9943C2.97421 6.97937 6.97937 2.95152 11.9943 2.95152C17.0093 2.95152 21.0371 6.97937 21.0485 11.9943C21.0598 17.0206 17.0206 21.0371 12.0057 21.0371ZM7.56937 17.3724L13.6735 14.4224C14.0253 14.2522 14.2635 14.0026 14.4337 13.6622L17.361 7.58071C17.7241 6.83187 17.1795 6.26457 16.4079 6.62764L10.3265 9.56627C9.99742 9.72512 9.75915 9.95204 9.57762 10.3265L6.62764 16.4193C6.28726 17.1454 6.84322 17.7127 7.56937 17.3724ZM12.0057 13.3332C11.2682 13.3332 10.6782 12.7432 10.6782 12.0057C10.6782 11.2795 11.2682 10.6782 12.0057 10.6782C12.7318 10.6782 13.3332 11.2795 13.3332 12.0057C13.3332 12.7432 12.7318 13.3332 12.0057 13.3332Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Safari24 } from '@cian/ui-kit/icons';`, <br />
 * где 24 - это размер иконки в пикселях.
 */

export var Safari24 = createIcon(IconComponent);